import { useStableCallback } from "@bezoned/shared/hooks/use-stable-callback.js";
import {
  Button,
  Dialog,
  DialogActions,
  DialogBody,
  DialogContent,
  DialogSurface,
  DialogTitle,
} from "@fluentui/react-components";

interface IntroductionVideoDialogProps {
  open: boolean;
  onDismiss: (action: "dismissed" | "doNotShowAgain") => void;
  videoId: string;
}

export const IntroductionVideoDialog = ({
  open,
  onDismiss,
  videoId,
}: IntroductionVideoDialogProps) => {
  const handleClose = useStableCallback(() => {
    onDismiss("dismissed");
  });

  const handleDoNotShowAgain = useStableCallback(() => {
    onDismiss("doNotShowAgain");
  });

  const youtubeUrl = `https://www.youtube.com/watch?v=${videoId}`;

  const handleVideoClick = useStableCallback(() => {
    window.open(youtubeUrl, "_blank", "noopener,noreferrer");
  });
  const handleOpenChange39 = useStableCallback(
    (_event, data) => !data.open && handleClose()
  );

  return (
    <Dialog onOpenChange={handleOpenChange39} open={open}>
      <DialogSurface>
        <DialogBody className="flex flex-col gap-6">
          <DialogTitle>Welcome to BeZoned!</DialogTitle>
          <DialogContent>
            <div className="flex flex-col gap-4">
              <p className="text-base">
                Watch this quick introduction video to get started with BeZoned.
              </p>
              <button
                aria-label="Open introduction video in new tab"
                className="relative cursor-pointer overflow-hidden rounded-lg border-0 bg-transparent p-0"
                onClick={handleVideoClick}
                type="button"
              >
                <img
                  alt="Introduction video thumbnail"
                  className="aspect-video w-full object-cover"
                  height={720}
                  src={`https://img.youtube.com/vi/${videoId}/sddefault.jpg`}
                  width={1280}
                />
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="bg-opacity-70 hover:bg-opacity-90 flex h-16 w-16 items-center justify-center rounded-full bg-black transition-all hover:h-20 hover:w-20">
                    <svg
                      className="ml-1 h-8 w-8 fill-white"
                      viewBox="0 0 24 24"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <title>Play video</title>
                      <path d="M8 5v14l11-7z" />
                    </svg>
                  </div>
                </div>
              </button>
            </div>
          </DialogContent>
          <DialogActions className="mt-2 flex w-full justify-end gap-2">
            <Button appearance="secondary" onClick={handleDoNotShowAgain}>
              Do not show again
            </Button>
            <Button appearance="primary" onClick={handleClose}>
              Close
            </Button>
          </DialogActions>
        </DialogBody>
      </DialogSurface>
    </Dialog>
  );
};
